import { cartCookieConfig } from '_config/constants/cookies';

export function deleteCookie(name) {
  document.cookie = `${name}=;max-age=0;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;samesite=none`;
}

export function deleteCartCookie() {
  deleteCookie(cartCookieConfig.name);
}
